import { render, staticRenderFns } from "./video_material.vue?vue&type=template&id=86645420&scoped=true&"
import script from "./video_material.vue?vue&type=script&lang=js&"
export * from "./video_material.vue?vue&type=script&lang=js&"
import style0 from "./video_material.vue?vue&type=style&index=0&id=86645420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86645420",
  null
  
)

export default component.exports